<template>  <div class="home">    <h1>Home</h1>  </div></template>
<script>export default {  name: 'home',  data () {    return {      msg: 'Welcome to Your Vue.js App'    }  }}</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>